/*
 * @Date: 2021-05-25 10:49:55
 * @LastEditors: Zelin
 * @LastEditTime: 2022-02-23 17:16:25
 * @FilePath: \sany-pub-pay-counter\src\api\modules\payService.js
 * @description: 这是做什么的。。。
 */
import Service from './Service';

/**
 * 支付模块接口
 */
class PayService extends Service {
    /**
     * 查询交易预支付参数
     * @param busiSn
     */
    queryPrePay(busiSn) {
        return this.axios.get('api/pay/v1/trade/prePay', {
            params: {
                busiSn: busiSn
            }
        });
    }
    /**
     * 查询银联支付参数
     * @param busiSn
     */
    queryUnionParam(busiSn) {
        return this.axios.get('api/pay/v1/trade/pay/getH5UnionParam', {
            params: {
                busiSn: busiSn
            }
        });
    }
    /**
     * 发送验证码
     * @param params
     */
    sendSms(params) {
        return this.axios.post('api/pay/v1/trade/captcha', params);
    }
    /**
     * 发送验证码(三湘)
     * @param params
     */
    sendSmsSX(params) {
        return this.axios.get('api/pay/v1/function/sendSMS', {
            params
        });
    }
    /**
     * 钱包或授信支付
     * @param params
     */
    walletPay(params) {
        return this.axios.post('api/pay/v1/trade/walletPay', params);
    }
    /**
     * dms钱包或授信支付
     * @param params
     */
    dmsWalletPay(params) {
        return this.axios.post('api/pay/v1/trade/dms/walletPay', params);
    }
    /**
     * 钱包或授信支付(三湘)
     * @param params
     */
    walletPaySX(params) {
        return this.axios.post('api/pay/v1/consume/walletPay', params);
    }
}

const payService = new PayService();
export default payService;
